enum TiposEtapas {
  Alistado = 'Alistado',
  Almacenado = 'Almacenado',
  Anulado = 'Anulado',
  AtenciónEnSitio = 'Atención en Sitio',
  AprobadoOrigen = 'Aprobado Origen',
  AprobadoDestino = 'Aprobado Destino',
  Cancelada = 'Cancelada',
  Cerrada = 'Cerrada',
  CerradoConParciales = 'Cerrado con Parciales',
  Consolidado = 'Consolidado',
  Conteo = 'Conteo',
  Conteo2 = 'Conteo 2',
  Creada = 'Creada',
  Despachado = 'Despachado',
  DespachoParcial = 'Despacho Parcial',
  EnAlistamiento = 'En Alistamiento',
  EnAlmacenamiento = 'En Almacenamiento',
  EntregaConfirmada = 'Entrega Confirmada',
  EntregaPlaneada = 'Entrega Planeada',
  EntregaTránsito = 'Entrega Tránsito',
  Fallida = 'Fallida',
  PlataformaDestino = 'Plataforma Destino',
  PlataformaOrigen = 'Plataforma Origen',
  Procesado = 'Procesado',
  Reasignada = 'Reasignada',
  RecepciónParcial = 'Recepción Parcial',
  RecogidaConfirmada = 'Recogida Confirmada',
  RecogidaPlaneada = 'Recogida Planeada',
  Revertido = 'Revertido',
  Transito = 'Tránsito',
  EnZonaDespacho = 'En Zona Despacho',
  DevolucionParcial = 'Devolución parcial',
  DevolucionTotal = 'Devolución total',
  EnDevolucion = 'En devolución',
}

export default TiposEtapas;
